import React from 'react'

interface InterfaceMDXText {
  file:string
}
export const MDXText = ({ file }:InterfaceMDXText) => {
  const Text = require('../_text/'+file).default
  return (
   <Text/>
  )
}
